import ChooseLoginMethod from './ChooseLoginMethod';
import Password from './Password';

type Step = {
  stepId: number;
  component: JSX.Element;
  progressOnMount: number;
};

export const steps: Step[] = [
  {
    stepId: 0,
    component: <ChooseLoginMethod />,
    progressOnMount: 0,
  },
  {
    stepId: 1,
    component: <Password />,
    progressOnMount: 1,
  },
];

export const getStepById = (stepId: number): Step | undefined =>
  steps.find((step) => step.stepId === stepId);
